import { render, staticRenderFns } from "./MethodItem.vue?vue&type=template&id=668ddd71&scoped=true&"
import script from "./MethodItem.vue?vue&type=script&lang=js&"
export * from "./MethodItem.vue?vue&type=script&lang=js&"
import style0 from "./MethodItem.vue?vue&type=style&index=0&id=668ddd71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668ddd71",
  null
  
)

export default component.exports